const translations = {
  "en": {
    "Upload materials": "Upload materials"
  },
  "zh-tw": {
    "Upload materials": "上傳檔案"
  }
};

export default translations;
